var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('b-icon',{attrs:{"icon":"eye"}}),_vm._v(" "+_vm._s(_vm.streamStatistic.view_count)+" ")],1),_c('span',{staticClass:"ml-4"},[_c('b-icon',{attrs:{"icon":"heart"}}),_vm._v(" "+_vm._s(_vm.getAllLikeCount)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }